import { create } from 'zustand';

export enum Themes {
  default = 'default',
  deloitte = 'deloitte',
}

// Map theme to its CSS class name (expandable for future themes)
const ThemeClassNames: Record<Themes, string | null> = {
  [Themes.default]: null,
  [Themes.deloitte]: 'deloitte-theme',
};

interface ThemeState {
  theme: Themes;
  isDeloitteTheme: boolean;
  setTheme: (theme: Themes) => void;
}

const removeTheme = () => {
  const body = document.body;
  Object.values(ThemeClassNames).forEach((className) => {
    if (className) body.classList.remove(className);
  });
};

export const useThemeStore = create<ThemeState>((set) => ({
  theme: Themes.default,
  isDeloitteTheme: false,
  setTheme: (theme) => {
    removeTheme();
    const className = ThemeClassNames[theme];
    if (className) {
      document.body.classList.add(className);
    }
    set({ theme, isDeloitteTheme: theme === Themes.deloitte });
  },
}));
